import * as yup from 'yup';

import {
  fieldStateYupValidation,
} from '@/shared/utils/validationSchema';

export const preagendamientoPymesFormSchema = yup.object({
  direccion: yup
    .string()
    .required('El campo dirección es requerido')
    .max(250, 'El campo dirección no debe exceder los 250 caracteres'),
  celular: yup
    .string()
    .required('El campo celular es requerido')
    .matches(/^09[0-9]{8}$/, 'Ingrese un número de teléfono válido en Ecuador'),
  /* celular_2: yup
    .string()
    .matches(/^09[0-9]{8}$/, 'Ingrese un número de teléfono válido en Ecuador'), */
  coordenadas: yup
    .string()
    .required('El campo coordenadas es requerido')
    .max(200, 'El campo coordenadas no debe exceder los 200 caracteres'),
  distancia: yup
    .string()
    .required('El campo distancia es requerido')
    .max(200, 'El campo distancia no debe exceder los 200 caracteres'),
  estado: fieldStateYupValidation,
  estado_llamada: yup
    .string()
    .when('solicitar_tecnico', {
      is: (solicitar_tecnico: boolean) => !solicitar_tecnico,
      then: schema => schema.required('El campo estado llamada es requerido')
    }).optional().nullable(),
  observacion_llamada: yup
    .string()
    .when('solicitar_tecnico', {
      is: (solicitar_tecnico: boolean) => !solicitar_tecnico,
      then: schema => schema.required('El campo observacion llamada es requerido')
    }).optional(),
  preventa: yup
    .string()
    .required('El campo preventa es requerido')
    .max(200, 'El campo preventa no debe exceder los 200 caracteres'),
  /* flota: yup
    .string()
    .required('El campo flota es requerido')
    .max(200, 'El campo flota no debe exceder los 200 caracteres'), */
  /* pais: yup
    .string()
    .required('El campo pais es requerido')
    .max(200, 'El campo pais no debe exceder los 200 caracteres'),
  provincia: yup
    .string()
    .required('El campo provincia es requerido')
    .max(200, 'El campo provincia no debe exceder los 200 caracteres'),
  ciudad: yup
    .string()
    .required('El campo ciudad es requerido')
    .max(200, 'El campo ciudad no debe exceder los 200 caracteres'),
  zona: yup
    .string()
    .required('El campo zona es requerido')
    .max(200, 'El campo zona no debe exceder los 200 caracteres'),
  sector: yup
    .string()
    .required('El campo sector es requerido')
    .max(200, 'El campo sector no debe exceder los 200 caracteres'), */
  isRejecting: yup.boolean().optional().nullable(),
  motivo_rechazo: yup
    .string()
    .nullable()
    .when('isRejecting', {
      is: true,
      then: schema =>
        schema
          .required('El campo motivo rechazo es requerido')
          .max(
            200,
            'El campo motivo rechazo no debe exceder los 200 caracteres'
          ),
    }),

  /* fecha_tecnico_adicional: yup
    .string()
    .when('solicitar_tecnico', {
      is: (solicitar_tecnico: boolean) => solicitar_tecnico,
      then: schema => schema.required('El campo estado fecha tecnico es requerido')
    }).optional().nullable(),
  hora_tecnico_adicional: yup
    .string()
    .when('solicitar_tecnico', {
      is: (solicitar_tecnico: boolean) => solicitar_tecnico,
      then: schema => schema.required('El campo estado hora tecnico es requerido')
    }).optional().nullable(), */

  observacion_tecnico_adicional: yup
    .string()
    .when('solicitar_tecnico', {
      is: (solicitar_tecnico: boolean) => solicitar_tecnico,
      then: schema => schema.required('El campo estado fecha tecnico es requerido')
    }).optional().nullable(),
});

export const preagendamientoSolicitudUpdFormSchema = yup.object({
  motivo_rechazo: yup
    .string()
    .required('El campo motivo rechazo es requerido')
    .max(200, 'El campo motivo rechazo no debe exceder los 200 caracteres'),
  estado_preagendamiento: yup
    .string()
    .required('El campo estado preagendamiento es requerido')
    .max(
      200,
      'El campo estado preagendamiento no debe exceder los 200 caracteres'
    ),
});
